import type { DislikedJobCardProps } from "../../../../../../jobcard/components/JobCard/JobCard";

import { Box, Pressable, type TextRef } from "../../../../../../mads";
import { ThumbsDown } from "../../../../../../mads/icons";
import { Text } from "../../../../../../mads/Text";
import { getFontSizeStyle } from "../../../../../../mads/Text/TextLevel";
import { useI18n } from "../../../../../../shared/I18n";
import useFocusOnNavigation from "../../../../hooks/useFocusOnNavigation";

import { colors } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { StyleSheet } from "react-native";

export function ViewJobDislikedJobCard({ undoDislikeJob, focusAfterRender }: DislikedJobCardProps) {
  const i18n = useI18n();
  const headerTextRef = React.useRef<TextRef>(null);

  useFocusOnNavigation(headerTextRef, { focusAfterRender: () => Boolean(focusAfterRender) });

  return (
    <Box sx={styles.container}>
      <Box>
        <Box sx={styles.header}>
          <Text ref={headerTextRef} sx={styles.title}>
            {i18n.gettext("Job hidden")}
          </Text>
          <ThumbsDown variant="filled" fill={colors.foregroundWeak} />
        </Box>
        <Text sx={styles.desc}>{i18n.gettext("We will not show you this job again")}</Text>
        <Box sx={styles.buttons}>
          <Pressable onPress={undoDislikeJob} accessibilityRole="button">
            <Text sx={styles.button}>{i18n.gettext("Undo")}</Text>
          </Pressable>
        </Box>
      </Box>
    </Box>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 320,
    padding: 16,
    borderRadius: 16,
    backgroundColor: colors.backgroundWeak,
  },
  header: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  title: {
    marginBottom: 4,
    ...getFontSizeStyle(2),
    fontWeight: "bold",
    color: colors.foregroundStrong,
  },
  desc: {
    marginBottom: 4,
    ...getFontSizeStyle(2),
  },
  buttons: {
    flexDirection: "row",
    alignItems: "center",
    columnGap: 16,
  },
  button: {
    ...getFontSizeStyle(2),
    fontWeight: "bold",
    color: colors.foregroundPrimary,
  },
});
